import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { REFERRED_BY_QUERY } from 'hooks/useAffiliateFormValuesExtension'
import useUtmQueryParams from 'hooks/useUtmQueryParams'
import { setDataToSessionStorage } from 'src/utils/sessionStorage'

const useReferredBySessionStorage = () => {
  const query = useSearchParams()
  useUtmQueryParams()
  useEffect(() => {
    const referredBy = query.get(REFERRED_BY_QUERY)
    if (referredBy) {
      setDataToSessionStorage(REFERRED_BY_QUERY, referredBy)
    }
  }, [query])
}

export default useReferredBySessionStorage
